module.exports = __webpack_public_path__ + "img/rsz_21credmap_homepage_1.e954ed12.jpg";